__turbopack_context__.v({
  "desg": "styles-module-scss-module__xmt_Bq__desg",
  "fixWidth": "styles-module-scss-module__xmt_Bq__fixWidth",
  "img": "styles-module-scss-module__xmt_Bq__img",
  "name": "styles-module-scss-module__xmt_Bq__name",
  "root": "styles-module-scss-module__xmt_Bq__root",
  "textContainer": "styles-module-scss-module__xmt_Bq__textContainer",
});
